import React, { useEffect, useState } from "react";
import { Btn } from "../../../AbstractElements";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { useGetStateList } from "../../Configuration/HolidayConfiguration/hooks/useHoliday";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import {
  useAddBranch,
  useUpdateBranch,
} from "../MastersScreen/hooks/useSettingsMasters";
import { Spinner } from "reactstrap";

interface BranchTableModalContentProps {
  handleClose: () => void;
  setIsModalOpen: any;
  selectedRow: any;
  modalStatus: string;
  branchId?: string | number;
  setformData?: any;
  formData?: any;
}

interface formDataInteface {
  Name_HQ: string | number;
  Branch_Code: string | number;
  State: string | number;
}
const BranchTableModalContent: React.FC<BranchTableModalContentProps> = ({
  handleClose,
  setIsModalOpen,
  selectedRow,
  modalStatus,
  branchId,
  setformData,
  formData,
}) => {
  console.log(
    "🚀 ~ BranchTableModalContent.tsx:27 ~ BranchTableModalContent ~ selectedRow:",
    selectedRow
  );

  // const [formData, setformData] = useState<formDataInteface>({
  //   Name_HQ: "",
  //   Branch_Code: "",
  //   State: "",
  // });

  const { data, isLoading, isSuccess } = useGetStateList({ enable: true });
  const { mutate: addBranch } = useAddBranch();
  const { mutate: updateBranch } = useUpdateBranch();

  const formated = Array.isArray(data?.data)
    ? data?.data.map((item: any) => ({
        id: item.id,
        label: item.name,
      }))
    : [];

  useEffect(() => {
    if (modalStatus === "Edit" && selectedRow)
      setformData({
        Name_HQ: selectedRow?.BranchName,
        Branch_Code: selectedRow?.BranchCode,
        State: selectedRow?.Istateid,
      });
  }, [selectedRow]);

  const handleInputChange = (
    name: any,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = e.target;

    // Convert specific fields to numbers
    const numericFields = ["attachment", "leavePoints"];
    const updatedValue = numericFields.includes(name)
      ? value.replace(/[^0-9]/g, "")
      : value;

    setformData((prevState: any) => ({
      ...prevState,
      [name]: numericFields.includes(name)
        ? updatedValue === ""
          ? ""
          : Number(updatedValue)
        : updatedValue,
    }));
  };

  const handleDropdownSelect = (field: string, value: string | number) => {
    setformData((prevState: any) => ({
      ...prevState,
      [field]: value, // Directly assign the selected value
    }));
  };

  const handleSubmit = () => {
    console.log("FORMDATA::::::::::::::", formData);

    if (modalStatus === "Edit" && branchId) {
      const updateBranchBody = {
        branchId: branchId,
        branchName: formData?.Name_HQ,
        branchCode: formData?.Branch_Code,
        stateId: formData?.State,
      };
      updateBranch(
        { id: branchId, body: updateBranchBody },
        {
          onSuccess: () => {
            setformData({ Name_HQ: "", Branch_Code: "", State: "" });
            setIsModalOpen(false);
          },
          onSettled: () => {
            setformData({ Name_HQ: "", Branch_Code: "", State: "" });
            setIsModalOpen(false);
          },
        }
      );
    } else {
      const addBranchBody = {
        branchName: formData?.Name_HQ,
        branchCode: formData?.Branch_Code,
        stateId: formData?.State,
      };
      addBranch(addBranchBody, {
        onSuccess: () => {
          setformData({ Name_HQ: "", Branch_Code: "", State: "" });
          setIsModalOpen(false);
        },
        onSettled: () => {
          setformData({ Name_HQ: "", Branch_Code: "", State: "" });
          setIsModalOpen(false);
        },
      });
    }
  };

  return (
    <>
      {selectedRow && modalStatus === "Edit" && !data ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "60vh" }}
        >
          <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
          {/* <span className="ms-3">Loading SGPI Brands...</span> */}
        </div>
      ) : (
        <div>
          <div className="row">
            <div className="col-md-12">
              <CustomInput
               asterisk
                label="Name / HQ"
                placeholder="Enter Name / HQ"
                type="text"
                name="Name_HQ"
                value={formData.Name_HQ}
                onChange={(e) => handleInputChange("Name_HQ", e)}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <CustomInput
                asterisk
                required
                label="Branch Code"
                placeholder="Enter Branch Code"
                type="text"
                name="Branch_Code"
                value={formData.Branch_Code}
                onChange={(e) => handleInputChange("Branch_Code", e)}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <ReusableDropdown
                options={(!isLoading && isSuccess && formated) || []}
                value={formData?.State}
                onChange={(value: any) => {
                  handleDropdownSelect("State", value);
                }}
                asterisk
                DropdownHeading="State"
                placeholder="Select State"
              />
            </div>
          </div>

          {/* Buttons */}
          <div className="d-flex justify-content-start mt-3 gap-2">
            <Btn
              style={{ backgroundColor: "#43B9B2", color: "white" }}
              type="submit"
              onClick={handleSubmit}
            >
              {modalStatus === "Edit" ? "Update" : "Submit"}
            </Btn>
            <Btn
              style={{
                backgroundColor: "#F9FAFC",
                color: "#000",
                border: "1px solid #E0E0E0",
              }}
              type="button"
              onClick={handleClose}
            >
              Cancel
            </Btn>
          </div>
        </div>
      )}
    </>
  );
};

export default BranchTableModalContent;
